import { GsFormSchema } from 'libs/shared/src/components/gs-form/interfaces/gs-form-schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the chainstore list component form.
 * Defines the fields to display for the form.
 */
export const CHAINSTORE_PLACES_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [...BASIC_SCHEMA_FIELDS, ...SPACING_SCHEMA]
};
